import i18n from "i18next";

export function tran(s, options) {
  return i18n.t(s, options);
}